import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {ElectionService} from "../Election/ElectionService";
import {CashGroupService} from "../../pages/CashGroups/CashGroupService";
import {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    Button,
    Chip, DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField, useMediaQuery, useTheme
} from "@material-ui/core";
import {convertToBirthDate, convertToTime} from "../../utils/numberConvertor";
import * as React from "react";
import CustomTable from "../customTable/CustomTable";
import ElectionVoteList from "./ElectionVoteList";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

let voteSelectedItem = -1
const ElectionInfo = ({openDialog, needRefresh, selectedItemId, handleClose}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new ElectionService(fundID, token, snackbar, loading)
    const groupService = new CashGroupService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (typeof groupService !== 'undefined') {
            getGroupList()
        }
    }, [])

    const [groupList, setGroupList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(-1);

    const [candidatesList, setCandidatesList] = useState([]);

    useEffect(() => {
        if (selectedItemId >= 0) {
            clearFields()
            getElectionData()
        }
    }, [selectedItemId])

    function getElectionData() {
        loading(setLoadingStateDispatch(true))
        service.getElectionInfo(fundID, selectedItemId)
            .then(response => {
                setElectionData(response.electionInfo)
                setElectionResult(response.electionResult)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت جزئیات انتخابات!",snackbar,loading)
        })
    }

    function setElectionResult(electionResult) {
        setVoteAmount(electionResult.totalVotes)
        setVoteList([])
        electionResult.candidatesVotesResults.map((item, index) => {
            setVoteList((prevState => [...prevState, {
                id: item.id,
                number: index + 1,
                title: item.title,
                totalVotes: item.totalVotes,
                percentOfVotes: item.percentOfVotes ? item.percentOfVotes : "صفر"
            }]))
        })
    }

    function setElectionData(electionData) {
        setTitle(electionData.title)
        setSelectedGroupId(parseInt(electionData.groupId))
        setStartDate(electionData.startPersianDate)
        setStartTime(electionData.startPersianTime)
        setEndDate(electionData.endPersianDate)
        setEndTime(electionData.endPersianTime)
        setEnabled(electionData.enabled)
        setPublished(electionData.published)
        setDescription(electionData.description)

        electionData.candidates.map((item, index) => {
            setCandidatesList((prevState => [...prevState, {
                key: item.id,
                label: item.title
            }]))
        })
    }

    const handleDelete = (chipToDelete) => () => {
        setCandidatesList((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };

    function getGroupList() {
        groupService.getCashGroupsList(fundID, 0, "", "", 50).then(response => {
            setGroupList(response.data)
        }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات گروه ها!"))
        })
    }

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    //Dialog-end


    //state-start
    const [title, setTitle] = useState('')
    const [startDate, setStartDate] = useState('')
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState('')
    const [endTime, setEndTime] = useState("");
    const [published, setPublished] = useState(false)
    const [enabled, setEnabled] = useState(true);
    const [options, setOptions] = useState("")
    const [description, setDescription] = useState('')

    const [voteAmount, setVoteAmount] = useState(-1);
    const [voteList, setVoteList] = useState([]);

    //state-end

    function checkAllFields() {
        let status = true
        let message = ""
        if (title.trim().length === 0) {
            status = false
            message = "لطفا عنوان انتخابات را وارد نمایید!"
        } else if (selectedGroupId === -1) {
            status = false
            message = "لطفا گروه را انتخاب نمایید!"
        } else if (startDate.length !== 10) {
            status = false
            message = "لطفا تاریخ شروع انتخابات را به درستی وارد نمایید!"
        } else if (endDate.length !== 10) {
            status = false
            message = "لطفا تاریخ پایان انتخابات را به درستی وارد نمایید!"
        } else if (candidatesList.length === 0) {
            status = false
            message = "لطفا نام کاندیدا ها وارد نمایید!"
        } else if (published) {
            status = false
            message = "امکان ویرایش انتخابات منتشر شده وجود ندارد!"
        } else if (!enabled) {
            status = false
            message = "امکان ویرایش انتخابات لغو شده وجود ندارد!"
        }

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return status

    }


    function doChange() {
        if (checkAllFields()) {
            needRefresh(true)
            service.updateElection(
                fundID,
                selectedGroupId,
                selectedItemId,
                service.prepareUpdateElectionData(
                    title,
                    startDate,
                    endDate,
                    published,
                    true,
                    candidatesList,
                    description
                )
            )

        }
    }

    function clearFields() {
        setTitle("")
        setStartDate("")
        setEndDate("")
        setStartTime("")
        setEndTime("")
        setSelectedGroupId(-1)
        setCandidatesList([])
        setDescription("")
        setPublished(false)
        setVoteList([])
        setVoteAmount(-1)
    }

    const [openChangeEnabledDialog, setOpenChangeEnabledDialog] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClickOpenChangeEnabledDialog = () => {
        setOpenChangeEnabledDialog(true);
    };

    const handleCloseChangeEnabledDialog = () => {
        setOpenChangeEnabledDialog(false);
    };

    function doDisableElection() {
        needRefresh(true)
        handleCloseChangeEnabledDialog()
        service.disableElection(fundID, selectedItemId, getElectionData)
    }


    const [openChangePublishedDialog, setOpenChangePublishedDialog] = React.useState(false);

    const handleClickOpenChangePublishedDialog = () => {
        setOpenChangePublishedDialog(true);
    };

    const handleCloseChangePublishedDialog = () => {
        setOpenChangePublishedDialog(false);
    };

    function doPublishElection() {
        needRefresh(true)
        handleCloseChangePublishedDialog()
        service.publishElection(fundID, selectedItemId, getElectionData)
    }

    const [openHandleEndDialog, setOpenHandleEndDialog] = React.useState(false);

    const handleClickOpenEndElectionDialog = () => {
        setOpenHandleEndDialog(true);
    };

    const handleCloseChangeEndElectionDialog = () => {
        setOpenHandleEndDialog(false);
    };

    function doEndElection() {
        needRefresh(true)
        handleCloseChangeEndElectionDialog()
        service.endElection(fundID, selectedItemId, getElectionData)
    }

    function extensionElection() {
        if (endDate.length === 10 && endTime.length === 5) {
            service.extensionElection(fundID, selectedItemId, endDate, endTime)
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "خطا، تاریخ یا زمان پایان نادرست می باشد!"))
        }
    }


    function showVoteContent(rowId) {
        voteSelectedItem = rowId
        handleOpenShowVoteContent()
    }

    const [openShowVoteContentDialog, setOpenShowVoteContentDialog] = useState(false);

    function handleOpenShowVoteContent() {
        setOpenShowVoteContentDialog(true)
    }

    function handleCloseShowVoteContent() {
        setOpenShowVoteContentDialog(false)
        voteSelectedItem = -1
    }

    return (
        <>
            <div>
                {
                    <ElectionVoteList
                        openDialog={openShowVoteContentDialog}
                        handleClose={handleCloseShowVoteContent}
                        selectedItemId={voteSelectedItem}
                        electionId={selectedItemId}
                    />
                }
                <Dialog
                    fullScreen={fullScreen}
                    open={openHandleEndDialog}
                    onClose={handleCloseChangeEndElectionDialog}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">پایان انتخابات</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            با پایان انتخابات امکان فعال سازی مجدد انتخابات وجود نخواهد داشت، آیا از پایان انتخابات
                            اطمینان
                            دارید؟!
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseChangeEndElectionDialog} className="btn-confirm px-4">
                            بیخیال
                        </Button>
                        <Button onClick={doEndElection} className="btn-secondary px-4">
                            پایان
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={openChangeEnabledDialog}
                    onClose={handleCloseChangeEnabledDialog}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">لغو انتخابات</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            با لغو انتخابات امکان فعال سازی مجدد انتخابات وجود نخواهد داشت، آیا از لغو انتخابات اطمینان
                            دارید؟!
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseChangeEnabledDialog} className="btn-confirm px-4">
                            بیخیال
                        </Button>
                        <Button onClick={doDisableElection} className="btn-secondary px-4">
                            غیر فعال کن
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={openChangePublishedDialog}
                    onClose={handleCloseChangePublishedDialog}
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle id="responsive-dialog-title">انتشار انتخابات</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            با انتشار انتخابات امکان ویرایش مجدد انتخابات وجود نخواهد داشت، آیا از انتشار انتخابات
                            اطمینان دارید؟!
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseChangePublishedDialog} className="btn-confirm px-4">
                            بیخیال
                        </Button>
                        <Button onClick={doPublishElection} className="btn-secondary px-4">
                            منتشر کن
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>


            <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                    id="customized-full-screen-dialog">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    جزئیات انتخابات
                </DialogTitle>
                <section className="w-100 d-flex justifyContentEnd px-4">
                    <Button onClick={handleClickOpenEndElectionDialog}
                            className={published && enabled ? "btn-secondary" : "d-none"}>
                        پایان انتخابات
                    </Button>
                    <Button onClick={handleClickOpenChangeEnabledDialog}
                            className={enabled ? "btn-secondary mx-2" : "d-none"}>
                        لغو انتخابات
                    </Button>
                    <Button className={published ? "d-none" : "btn-secondary mx-2"}
                            onClick={handleClickOpenChangePublishedDialog}>
                        انتشار
                    </Button>
                    <Button onClick={doChange} className={!enabled || published ? "d-none" : "btn-confirm"}>
                        بروزرسانی
                    </Button>
                    <Button
                        className={published ? "btn-confirm mx-2" : "d-none"}
                        onClick={extensionElection}>
                        تمدید انتخابات
                    </Button>
                </section>
                <section className="m-4">
                    <Box className="flex-grow-1 w-100" sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                                <TextField
                                    disabled={!enabled || published}
                                    className='w-100' variant="outlined" label="عنوان"
                                    value={title} onChange={e => {
                                    setTitle(e.target.value)
                                }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">گروه</InputLabel>
                                    <Select
                                        disabled={!enabled || published}
                                        label="گروه"
                                        value={selectedGroupId}
                                        onChange={e => {
                                            setSelectedGroupId(e.target.value)
                                        }}>
                                        {groupList.map((item, index) => {
                                            return <option value={item.id}>{item.name}</option>

                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField disabled={!enabled || published} className='w-100' variant="outlined"
                                           label="تاریخ شروع"
                                           value={convertToBirthDate(startDate)}
                                           onChange={e => {
                                               setStartDate(convertToBirthDate(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField disabled={!enabled || published} className='w-100' variant="outlined"
                                           label="زمان شروع"
                                           value={convertToTime(startTime)}
                                           onChange={e => {
                                               setStartTime(convertToTime(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined"
                                           label="تاریخ پایان"
                                           value={convertToBirthDate(endDate)}
                                           onChange={e => {
                                               setEndDate(convertToBirthDate(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="زمان پایان"
                                           value={convertToTime(endTime)}
                                           onChange={e => {
                                               setEndTime(convertToTime(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100 d-flex flex-column'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">وضعیت انتشار</InputLabel>
                                    <Select label="وضعیت انتشار"
                                            value={published}
                                            disabled
                                    >
                                        <option value={true}>منتشر شده</option>
                                        <option value={false}>در انتظار انتشار</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100 d-flex flex-column'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">وضعیت</InputLabel>
                                    <Select label="وضعیت"
                                            value={enabled}
                                            disabled
                                    >
                                        <option value={true}>فعال</option>
                                        <option value={false}>بسته شده</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <label className={candidatesList.length > 0 ? "d-block" : "d-none"}>کاندید ها</label>
                                <section className="d-flex flex-row flex-wrap">
                                    {candidatesList.map((data) => {
                                        return (
                                            <Chip
                                                label={data.label}
                                                onDelete={enabled && !published ? handleDelete(data) : ""}
                                                className="mx-2 my-2"
                                                key={data.key}
                                            />
                                        );
                                    })}
                                </section>
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12}
                                  className={enabled && !published ? "p-2 w-100" : "d-none"}>

                                <TextField
                                    className="w-100"
                                    label="کاندید جدید"
                                    helperText="افزودن با اینتر"
                                    variant="outlined"
                                    value={options}
                                    onChange={e => {
                                        setOptions(e.target.value)
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter') {
                                            const key = candidatesList.length > 0 ? parseInt(candidatesList[candidatesList.length - 1].key) + 1 : "0"
                                            setCandidatesList((prevState => [...prevState, {
                                                key: key,
                                                label: options
                                            }]))
                                            setOptions("")
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <TextField
                                    className="w-100"
                                    label="توضیحات"
                                    multiline
                                    rows={6}
                                    disabled={!enabled || published}
                                    variant="outlined"
                                    value={description}
                                    onChange={e => {
                                        setDescription(e.target.value)
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </section>
                <section className="w-100">
                    <Box sx={12} className="mx-4 d-flex flex-column justifyContentStart btn-secondary py-1">
                        <span className="fs-3">نتایج انتخابات</span>
                        <span
                            className="fs-1 mt-2">{voteAmount >= 0 ? `${voteAmount} رای ثبت شده` : `نتایج هنوز منتشر نشده است!`}</span>
                    </Box>
                    <div className="m-4">
                        <CustomTable
                            header={columns}
                            data={voteList}
                            rowClicked={showVoteContent}
                            title={"نتایج هنوز مشخص نشده است!"}
                        />
                    </div>
                </section>
            </Dialog>
        </>
    )

};

export default ElectionInfo;

const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'title', label: 'عنوان', align: 'right'},
    {id: 'totalVotes', label: 'تعداد آرا', align: 'right'},
    {id: 'percentOfVotes', label: 'درصد آرا', align: 'right'},
];